import React from 'react';
import ChuckCard from './components/ChuckCard';

function App() {
  return (
    <main className="App">
      <ChuckCard />
    </main>
  );
}

export default App;
